import { Store } from '@tanstack/store'
import { useStore } from '@tanstack/react-store'

export interface CurrentOrganizationState {
  organizationId: string | null
}

export const currentOrganizationStore = new Store<CurrentOrganizationState>({
  organizationId: null,
})

export const currentOrganizationActions = {
  setOrganizationId(organizationId: string | null) {
    currentOrganizationStore.setState(() => ({
      organizationId,
    }))
  },
  syncWithAvailableOrganizations(organizationIds: Array<string>) {
    currentOrganizationStore.setState((state) => {
      if (state.organizationId && organizationIds.includes(state.organizationId)) {
        return state
      }

      return {
        organizationId: organizationIds[0] ?? null,
      }
    })
  },
}

export function useCurrentOrganizationStore() {
  const state = useStore(currentOrganizationStore)
  return { ...state, ...currentOrganizationActions }
}
